/**
 * Shared constants for the JS Expandable feature.
 * Consumed by both the frontend runtime (src/frontend/js/js-expandable.js) and
 * the editor panel (src/editor/js/style-panels/expandable/*) to prevent drift.
 */

// Must match the 'phone' breakpoint in design-system/tokens.json.
export const MOBILE_BREAKPOINT = 1024;

// Ancestor selectors used to scope trigger→target lookups and to mark parent
// containers with `has-expandable` / `has-expanded` classes.
export const EXPANDABLE_PARENT_SELECTORS = [
	'[class*="gb-looper-"]',
	'.generateprop-grid',
	'.program-row',
	'.generateprop-card',
	'.generateprop-slider__slide',
	'.generateprop-container',
];

// Human-readable labels for scope selectors surfaced in the editor UI.
export const SCOPE_LABELS = {
	'[class*="gb-looper-"]': 'Nearest loop item',
	'.generateprop-grid': 'Nearest grid',
	'.program-row': 'Nearest program row',
	'.generateprop-card': 'Nearest card',
	'.generateprop-slider__slide': 'Nearest slide',
};

// Data-attribute keys.
export const DATA_COLLAPSED_HEIGHT = 'data-collapsed-height';
export const DATA_EXPAND_ID = 'data-expand-id';
export const DATA_EXPAND_TARGET = 'data-expand-target';
export const DATA_EXPAND_SCOPE = 'data-expand-scope';
export const DATA_EXPAND_MOBILE_ONLY = 'data-expand-mobile-only';
export const DATA_EXPAND_LABEL_COLLAPSED = 'data-expand-label-collapsed';
export const DATA_EXPAND_LABEL_EXPANDED = 'data-expand-label-expanded';
export const DATA_EXPAND_ICON_EXPANDED = 'data-expand-icon-expanded';
export const DATA_EXPAND_TEXT = 'data-expand-text';

// Marker on an ancestor that opts a group of expandables into accordion-style
// behavior: expanding any one collapses every other open expandable inside the
// same `[data-expand-exclusive]` ancestor.
export const DATA_EXPAND_EXCLUSIVE = 'data-expand-exclusive';

// Selectors whose matched elements are auto-stamped with `data-expand-exclusive`
// on init. Use this to opt entire design-system patterns into accordion-style
// behavior without editing page markup. Add a selector here when an entire
// grouping (e.g. a section type) should always behave as a single-open group.
export const EXCLUSIVE_AUTO_SELECTORS = [
	// Success Stories: the grid wrapping any `.card--success-story` cards.
	'[class*="generateprop-grid"]:has(.card--success-story)',
];

// CSS class applied to collapsible content.
export const EXPANDABLE_CLASS = 'js-expandable';

// Block names eligible for the Expandable panel.
export const EXPANDABLE_TARGET_BLOCKS = [
	'generateblocks/element',
	'generateblocks/text',
	'generateblocks/container',
	'generateblocks/looper',
	'generateblocks/media',
];

export const EXPANDABLE_TRIGGER_BLOCKS = [
	'generateblocks/element',
	'generateblocks/text',
];
